import { RuntimeEngine, SceneManager, SelectManager } from '@easytwin/runtime';
import { useBindSignal } from './useBindSignal';
import { useDumbState } from './useDumbState';

export const useSelectManager = (engine: RuntimeEngine | undefined) => {
  const refresh = useDumbState();
  const sceneManager = engine?.getManager(SceneManager);
  const selectManager = sceneManager?.mainScene?.getManager(SelectManager);
  useBindSignal(sceneManager?.signals.sceneUpdated, refresh);
  return selectManager;
};
